import Model from '../orm/Model'

export default class ScanCode extends Model {

    static entity = 'scan_code'

    static fields() {
        return {
            code: this.attr(null)
        }
    }

    static graphql = {
        one: {
            type: 'scanCode',
            parameters: {
                uuid: 'String!',
            }
        }
    }
}
